export default __webpack_public_path__ + "static/media/sort.645333e2.svg";